import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';
import {
  FORUM_FEEDBACK_HEADER_TRUNCATE_LENGTH,
  Highlight,
} from '@modules/feedback/types';
import { Stack, Typography } from '@mui/material';
import truncate from 'lodash/truncate';
import { useEffect, useState } from 'react';
import { FeedbackDetailsConversationVariant } from 'v2/core/entities/feedback';
import { ForumContent } from 'v2/core/entities/feedback/content';

interface ForumMessageTypeHeaderProps {
  showOriginalLanguage: boolean;
  sourceTitle?: string;
  content?: ForumContent;
  isCollapsed: boolean;
  highlights: {
    [key: string]: Highlight[];
  };
  variant: FeedbackDetailsConversationVariant;
}

const ForumMessageTypeHeader = ({
  showOriginalLanguage,
  sourceTitle,
  content,
  highlights,
  isCollapsed,
  variant,
}: ForumMessageTypeHeaderProps) => {
  const [containsHighlights, setContainsHighlights] = useState(false);

  useEffect(() => {
    // Figure out if the Header contains highlights. For Header, the index is
    // always 0.
    if (Object.keys(highlights).indexOf('0') > -1) {
      setContainsHighlights(true);
    }
  }, [highlights]);

  const isPreview = variant === 'preview';

  const highlightsNodeContent = containsHighlights ? (
    <HighlightedFeedbackText
      text={content?.header?.text!}
      highlights={highlights[0]}
      showOriginalLanguage={showOriginalLanguage}
    />
  ) : null;

  const truncateLength = isPreview
    ? FORUM_FEEDBACK_HEADER_TRUNCATE_LENGTH.Preview
    : FORUM_FEEDBACK_HEADER_TRUNCATE_LENGTH.Default;
  const headerText = isCollapsed
    ? truncate(content?.header?.text, {
        length: truncateLength,
      })
    : content?.header?.text;

  return (
    <Stack spacing={isPreview ? 0 : 2} padding={3} paddingBottom={0}>
      <Stack spacing={1}>
        <Typography
          variant={isPreview ? 'body1' : 'h6'}
          fontWeight={500}
          sx={{
            wordBreak: 'break-word',
            opacity: 0.7,
            maxWidth: '90%',
          }}
        >
          {sourceTitle}
        </Typography>
        {!isPreview && (
          <Typography
            variant="body2"
            sx={{
              wordBreak: 'break-word',
              opacity: 0.5,
            }}
          >
            Post by {content?.header?.actorID}
          </Typography>
        )}
      </Stack>
      <Typography
        variant={isPreview ? 'body2' : 'body1'}
        sx={{
          wordBreak: 'break-word',
          opacity: isPreview ? 0.5 : 0.7,
          whiteSpace: 'pre-line',
        }}
      >
        {containsHighlights ? highlightsNodeContent : headerText}
      </Typography>
    </Stack>
  );
};

export default ForumMessageTypeHeader;
